import React, { useState } from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactAnimation from 'shared/design-system/base/TrueImpactAnimation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

interface CardGuideProps {
  text?: string | JSX.Element;
  padding: string;
}

const StyledDiv = styled.div<{ open: boolean; padding: string }>`
  margin-bottom: 20px;
  .guide-button {
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    svg {
      width: 16px;
      height: 16px;
      margin-top: -1px;
      margin-left: ${SPACERS.tiny};
      transition: transform 0.5s;
      ${({ open }) => (open ? 'transform: rotate(-180deg);' : '')}
    }
  }
  .guide-example {
    width: 100%;
    text-align: left;
    ${({ padding }) => padding}
    margin-top: ${SPACERS.small};
    padding-top: ${SPACERS.small};
    background: ${COLORS.grayLight};
    padding-bottom: ${SPACERS.small};
  }
  .guide-label {
    margin-bottom: ${SPACERS.tiny};
  }
`;

const CardGuide: React.FC<CardGuideProps> = ({ text, padding }) => {
  const [open, setOpen] = useState<boolean>(false);
  if (!text) return null;
  const handleToggle = () => setOpen(o => !o);
  return (
    <StyledDiv open={open} padding={padding}>
      <TrueImpactText
        onClick={handleToggle}
        variant="body"
        className="guide-button"
      >
        More guidance
        <FontAwesomeIcon icon={faChevronDown} color={COLORS.ctaPrimary} />
      </TrueImpactText>
      {open && (
        <TrueImpactAnimation variant="pulse">
          <div className="guide-example">
            <TrueImpactText variant="body-bold" className="guide-label">
              <strong>For example: </strong>
            </TrueImpactText>
            <TrueImpactText variant="body">{text}</TrueImpactText>
          </div>
        </TrueImpactAnimation>
      )}
    </StyledDiv>
  );
};

export default CardGuide;
